export default "__VITE_ASSET__f47517c4__"